import { PayloadAction } from '@reduxjs/toolkit';

import { TemplatesState } from 'editor/src/store/editorModules/templates/types';

const removeDesignTemplateReducer = (state: TemplatesState, action: PayloadAction<{ id: string }>) => {
  state.designTemplates = state.designTemplates.filter((template) => template.id !== action.payload.id);
};

export default removeDesignTemplateReducer;
